import {MapeadorBasico} from "../mapeadores/MapeadorBasico";
import {Catalogo} from "./catalogo/Catalogo";

export abstract class  ObjetoPersistente {
  id: any;
  async salve(graph: boolean = false): Promise<void> {
    const erro = await this.valide();
    if(erro) throw erro;
    if(this.id) await this.atualize();
    else if(graph) await this.insiraGraph();
    else await this.insira();
  }

  async atualize(){
    return this.mapeador().atualizeSync(this)
  }

  async remova(){
    return this.mapeador().removaAsync(this)
  }

  async insira(){
    return this.mapeador().insiraSync(this)
  }

  async insiraGraph(){
    return this.mapeador().insiraGraph(this)
  }

  async valide( contexto: any = null, catalogo: any = null): Promise<any>{
    return null;
  }

  abstract mapeador(): MapeadorBasico;
}
